if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        //Ticket ASNT-37: Azie
        let selectedThumbnail = activeMedia.querySelector('.thumbnail-zoom');
        this.loadPreviewFirst(selectedThumbnail);
        //activeMedia.scrollIntoView();

        /*const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;*/

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      //Ticket ASNT-37: Azie
      loadPreviewFirst(thumbnail){
        const preview = document.getElementById('productModalPreview');
        const mediaType = thumbnail.dataset.mediaType;
        const mediaUrl = thumbnail.dataset.mediaUrl;
        const videoSrc = thumbnail.dataset.videoSrc;

        if (mediaType === 'image') {
          preview.innerHTML = `<div class="zoom-container">
                                  <img class="zoom-image global-media-settings global-media-settings--no-shadow product__media-item--variant zoomable"
                                      src="${mediaUrl}"
                                      alt="${thumbnail.alt}"
                                      loading="lazy">
                              </div>`;
        } else if (mediaType === 'video') {
            preview.innerHTML = `<video playsinline controls autoplay="autoplay" preload="none" muted aria-label="${thumbnail.alt}" poster="${mediaUrl}" width="1100" height="1651">
                                  <source src="${videoSrc}" type="video/mp4">
                                  <img alt="${thumbnail.alt}" src="${mediaUrl}">
                                </video>`;
        }
      }

    }

  );
}
